import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { updateColumns } from 'bundles/apex/pipeline/settings/store/actions';

import AddControl from 'components/add_control';
import withDragDropContext from 'helpers/react_dnd/with_drag_drop_context';
import CustomColumn from './custom_column';

export function CustomColumnsSettings({ columnOptions, selectedColumns, updateColumns }) {
  const { all, available } = columnOptions;

  function handleColumnUpdate(index, value) {
    const columns = [...selectedColumns];
    columns.splice(index, 1, value);
    updateColumns(columns);
  }

  function handleAddColumn() {
    updateColumns([...selectedColumns, columnOptions.available[0].value]);
  }

  function handleRemoveColumn(index) {
    updateColumns(selectedColumns.filter((_, i) => i !== index));
  }

  function handleReorder(fromValue, toValue) {
    const fromIndex = selectedColumns.indexOf(fromValue);
    const toIndex = selectedColumns.indexOf(toValue);
    if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) return;

    const next = [...selectedColumns];
    const [moved] = next.splice(fromIndex, 1);
    next.splice(toIndex, 0, moved);
    updateColumns(next);
  }

  return (
    <div className="d-flex flex-column gap-3 my-3">
      <label className="form-label">Customize Pipeline Columns</label>
      {selectedColumns.map((value, index) => (
        <CustomColumn
          allOptions={all}
          availableOptions={available}
          columnIndex={index}
          key={value}
          value={value}
          onChange={handleColumnUpdate}
          onDelete={() => handleRemoveColumn(index)}
          onReorder={handleReorder}
        />
      ))}
      {available.length > 0 && <AddControl onClick={handleAddColumn}>Add Custom Column</AddControl>}
    </div>
  );
}

CustomColumnsSettings.propTypes = {
  columnOptions: PropTypes.shape({
    all: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    available: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  selectedColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
  updateColumns: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  columnOptions: state.columnOptions,
  selectedColumns: state.view.columns,
});

const mapDispatchToProps = {
  updateColumns,
};

export default connect(mapStateToProps, mapDispatchToProps)(withDragDropContext(CustomColumnsSettings));
